import * as stylex from "@stylexjs/stylex";
import type { HTMLAttributes, ReactNode } from "react";
import "../tokens.stylex.ts";
import { space } from "../tokens.stylex.ts";
type Gap = "none" | "xs" | "sm" | "md" | "lg" | "xl" | "xxl" | "x3";
interface FlexProps extends Omit<HTMLAttributes<HTMLDivElement>, "className" | "style"> {
  gap?: Gap;
  align?: "start" | "center" | "end" | "stretch" | "baseline";
  justify?: "start" | "center" | "end" | "between";
  wrap?: boolean;
  grow?: boolean;
  children?: ReactNode;
}

/** Vertical stack. */
export function Stack({
  gap = "md",
  align = "stretch",
  justify = "start",
  wrap,
  grow,
  ...rest
}: FlexProps) {
  return <div {...rest} {...stylex.props(styles.flex, styles.column, gaps[gap], aligns[align], justifies[justify], wrap && styles.wrap, grow && styles.grow)} />;
}

/** Horizontal row. */
export function Inline({
  gap = "sm",
  align = "center",
  justify = "start",
  wrap,
  grow,
  ...rest
}: FlexProps) {
  return <div {...rest} {...stylex.props(styles.flex, styles.row, gaps[gap], aligns[align], justifies[justify], wrap && styles.wrap, grow && styles.grow)} />;
}
export function Spacer() {
  return <div className="x1iyjqo2 xeuugli" />;
}
const styles = {
  flex: {
    k1xSpc: "x78zum5",
    k7Eaqz: "xeuugli",
    $$css: true
  },
  column: {
    kXwgrk: "xdt5ytf",
    $$css: true
  },
  row: {
    kXwgrk: "x1q0g3np",
    $$css: true
  },
  wrap: {
    kwnvtZ: "x1a02dak",
    $$css: true
  },
  grow: {
    kzQI83: "x1iyjqo2",
    k7Eaqz: "xeuugli",
    $$css: true
  }
};
const gaps = {
  none: {
    kOIVth: "x5t2z05",
    $$css: true
  },
  xs: {
    kOIVth: "xjenv9e",
    $$css: true
  },
  sm: {
    kOIVth: "x1a62zme",
    $$css: true
  },
  md: {
    kOIVth: "xpcbtbh",
    $$css: true
  },
  lg: {
    kOIVth: "x4l6xbm",
    $$css: true
  },
  xl: {
    kOIVth: "x18w2rdc",
    $$css: true
  },
  xxl: {
    kOIVth: "x9p7km9",
    $$css: true
  },
  x3: {
    kOIVth: "xxyh0xd",
    $$css: true
  }
};
const aligns = {
  start: {
    kGNEyG: "x1cy8zhl",
    $$css: true
  },
  center: {
    kGNEyG: "x6s0dn4",
    $$css: true
  },
  end: {
    kGNEyG: "xuk3077",
    $$css: true
  },
  stretch: {
    kGNEyG: "x1qjc9v5",
    $$css: true
  },
  baseline: {
    kGNEyG: "x1pha0wt",
    $$css: true
  }
};
const justifies = {
  start: {
    kjj79g: "x1nhvcw1",
    $$css: true
  },
  center: {
    kjj79g: "xl56j7k",
    $$css: true
  },
  end: {
    kjj79g: "x13a6bvl",
    $$css: true
  },
  between: {
    kjj79g: "x1qughib",
    $$css: true
  }
};